export default __webpack_public_path__ + "static/GT-America-Standard-Bold-158ff5ebc348a83152f683357666e77b.woff";